import type { Column } from "./ui/DataTable";

interface PrintTableProps<T> {
  rows: T[];
  columns: Column<T>[];
  title?: string;
}

/**
 * Print-only tabel. Wordt alleen zichtbaar bij afdrukken (via .print-area in index.css).
 * Browser "Save as PDF" levert de schone tabel-PDF.
 */
export function PrintTable<T>({ rows, columns, title }: PrintTableProps<T>) {
  return (
    <div className="print-area hidden print:block">
      {title && <h1 className="text-xl font-bold mb-3">{title}</h1>}
      <table className="w-full border-collapse text-xs">
        <thead>
          <tr>
            {columns.map((col) => (
              <th key={col.key} className="border border-slate-400 px-2 py-1 text-left font-bold">
                {col.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={i}>
              {columns.map((col) => (
                <td key={col.key} className="border border-slate-400 px-2 py-1">
                  {String(col.accessor(row) ?? "")}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}